export const buttons_MATERIAL_TYPE = 'buttons';
export const FABRIC_MATERIAL_TYPE = 'fabric';
export const STRINGS_MATERIAL_TYPE = 'strings';
export const VENDOR_MATERIAL_TYPE = 'remark_birka';
